(function(api) {
	api.izracunajVrijemePrelaskaGranice = izracunajVrijemePrelaskaGranice;	
	api.izracunajTrajanjeIzDatuma = izracunajTrajanjeIzDatuma;
	api.izracunajTrajanjeIzDecimalnog = izracunajTrajanjeIzDecimalnog;
	api.izracunajTrajanjeIzSatiMinuta = izracunajTrajanjeIzSatiMinuta;	
	api.promjenaStatusaPoziv = promjenaStatusaPoziv;
	api.promjenaStatusaPozivUPozadini = promjenaStatusaPozivUPozadini;	
	api.promjenaStatusaPozivBezDizanjaErrora = promjenaStatusaPozivBezDizanjaErrora;
	api.getNalogeIstogZahtjeva = getNalogeIstogZahtjeva;	
	api.prenesiZahtjevUPn = prenesiZahtjevUPn;
	api.generirajRelacije = generirajRelacije;	
	api.generirajDnevnice = generirajDnevnice;	
	api.obracunDefault = obracunDefault;	
	api.getPocetnoStanjeKm = getPocetnoStanjeKm;	
	api.getPocetnoStanjeKmIzRelacija = getPocetnoStanjeKmIzRelacija;	
	api.getZavrsnoStanjeKmIzRelacija = getZavrsnoStanjeKmIzRelacija;	
	api.getDatumIzRelacija = getDatumIzRelacija;	
 	api.getPutniById = getPutniById; 	
	api.postojeRelacije = postojeRelacije;
	api.postojeDnevnice = postojeDnevnice;	
	api.relacijaById = relacijaById;	
	api.getStatusi = getStatusi; 	 	
	api.getVoziloById = getVoziloById;
	api.odobriAkontaciju = odobriAkontaciju;	
	api.odbijAkontaciju = odbijAkontaciju;	
	api.isplatiAkontaciju = isplatiAkontaciju;
	api.ponistiIsplatuAkontacije = ponistiIsplatuAkontacije;	
	api.odobriPutniOsoba = odobriPutniOsoba;	
	api.odobriPutniOsobaSve = odobriPutniOsobaSve;	
	api.odbijPutniOsoba = odbijPutniOsoba;	
	api.provjeriAkoJeNalogZakljucan = provjeriAkoJeNalogZakljucan;
	api.generirajWebKorisnikaNaMail = generirajWebKorisnikaNaMail;
	api.webKorisnikJeKreiran = webKorisnikJeKreiran;
	api.predloziNazivWebKorisnika = predloziNazivWebKorisnika;
	api.getZOsobaByDjelatnik = getZOsobaByDjelatnik; 
	api.promjenaRedosljedaStavke = promjenaRedosljedaStavke; 
	api.getIznos1Km = getIznos1Km; 
	api.getStatusSOpcijom = getStatusSOpcijom;
	api.getPutniRelFields = getPutniRelFields;
	api.getPutniAkFields = getPutniAkFields;
	api.getPutniDnFields = getPutniDnFields;
	api.getPutniTrFields = getPutniTrFields;
	api.getPutniOdFields = getPutniOdFields;
	api.getPutniDetFields = getPutniDetFields;	
	api.getPutniDetZahtjevFields = getPutniDetZahtjevFields;	
	api.getPutniOsobaFields = getPutniOsobaFields;	
	api.getOpcijaIzStatusa = getOpcijaIzStatusa;	
	api.kontrolaKonta = kontrolaKonta;
    api.predloziIzVrKonta = predloziIzVrKonta;
    api.potpisnikPredlozi = potpisnikPredlozi;    
    api.tajnicaUpisala = tajnicaUpisala;    
    api.ponovnoSlanjeMaila = ponovnoSlanjeMaila;    
    api.rucnoSlanjeMaila = rucnoSlanjeMaila;    
    api.provjeriOvlastenjeOdobravanja = provjeriOvlastenjeOdobravanja;    
	api.knjigaSpById = knjigaSpById;
	api.opcinaById = opcinaById;	
	api.getIznosTecaja = getIznosTecaja;	
	api.vratiTecajZaValutuIDatum = vratiTecajZaValutuIDatum;	
	api.getIznosDnevnice = getIznosDnevnice;
	api.getIznosDnevnicePutni = getIznosDnevnicePutni;	
	api.razdvojiDnevnicu = razdvojiDnevnicu;
	api.getDnevnicaByDrzava = getDnevnicaByDrzava;		
	api.promjenaStatusaPutniRel = promjenaStatusaPutniRel;
    api.renumerirajBrojeve = renumerirajBrojeve;
	api.VratiCert = vratiCert;
	api.getPrviPutniByZahtjevId = getPrviPutniByZahtjevId;
	api.dohvatiDatotekuZaPotpisSP = dohvatiDatotekuZaPotpisSP;
	api.VratiPrazanDPObjekt = VratiPrazanDPObjekt;
	api.provjeriPotpisPoReduAsync = provjeriPotpisPoReduAsync;
	api.provjeriOdobravanjeNaRedu = provjeriOdobravanjeNaRedu;	
	api.predloziAktivnostIIzvore = predloziAktivnostIIzvore;
	api.getStatusiPromjena = getStatusiPromjena;
	api.sljedeciOdobravatelj = sljedeciOdobravatelj;
	api.deaktivirajOvlastenje = deaktivirajOvlastenje;
    api.otvoriNovuGodinu = otvoriNovuGodinu;
    api.vratiDatumZaRacunanjeDnevniceWEB = vratiDatumZaRacunanjeDnevniceWEB;
    api.vratiDatumPocetkaPutovanjaWEB = vratiDatumPocetkaPutovanjaWEB;
    api.vratiDatumKrajaPutovanjaWEB = vratiDatumKrajaPutovanjaWEB;
    api.vratiDatumZaTroskovePrijevozaWEB = vratiDatumZaTroskovePrijevozaWEB;    
    api.dohvatiZadnjiVrijediDoDnevnice = dohvatiZadnjiVrijediDoDnevnice;
    api.vratiSveNeodobreneOsobe = vratiSveNeodobreneOsobe;    
	api.kopirajObracun = kopirajObracun;    
	api.azurirajStatusUPozadini = azurirajStatusUPozadini;
	api.posloziOpisPrijevoza = posloziOpisPrijevoza;
	api.GetPutniKalendarEvents = GetPutniKalendarEvents;
	api.DjelatnikById = DjelatnikById;
	api.ProvjeriAutomatskiUpisOdredista = ProvjeriAutomatskiUpisOdredista;
	api.IstoVoziloPoRegOznaka = IstoVoziloPoRegOznaka;		
	api.GetDefVoziloZaVrstuPrijevoza = GetDefVoziloZaVrstuPrijevoza;
	api.VratiSljedecuSifruDjelatnika = VratiSljedecuSifruDjelatnika; 	
	api.ProvjeriSifruDjelatnika = ProvjeriSifruDjelatnika;
	api.azurInoDnev2024 = azurInoDnev2024;
	api.dohvatiHrmSifarnike = dohvatiHrmSifarnike;	
	api.ProvjeriZauzetostVozila = ProvjeriZauzetostVozila;
	api.posaljiNalogUHrmTravel = posaljiNalogUHrmTravel;	

	function getPrviPutniByZahtjevId(zahtjev, vrstaCert) {
		return $.dsDirectCall({ 
			method: "PrviPutniByZahtjevId",
			params: [zahtjev, vrstaCert]
		});
	}	
			
	function dohvatiDatotekuZaPotpisSP(putni, statusNovi, vrstaCert) { 
		return $.dsDirectCall({
            method: "DohvatiDatotekuZaPotpisSP",
            params: [putni, statusNovi, vrstaCert]
        });
	}

	function VratiPrazanDPObjekt() { 
		return $.dsDirectCall({
            method: "VratiPrazanDPObjekt"
        });
	}

	function vratiCert() { 
		return $.dsDirectCall({
            method: "VratiCert"
        });
	}

	function promjenaStatusaPutniRel(putniRel, status, poruka) {
		return $.dsDirectCall({ 
			method: "PromjenaStatusaPutniRel",
			params: [putniRel, status, poruka]
		});
	}	


	function razdvojiDnevnicu(dnevnica) { 
		return $.dsDirectCall({ 
			method: "RazdvojiDnevnicu", 
			params: [dnevnica]
		});   
	}

	function getIznosTecaja(putni, valuta) { 
		return $.dsDirectCall({ 
			method: "GetIznosTecaja", 
			params: [putni, valuta]
		});   
	}

	function vratiTecajZaValutuIDatum(vrstaTecaja, valuta, datum, drzava, drzavaNaziv) { 
		return $.dsDirectCall({ 
			method: "VratiTecajZaValutuIDatum", 
			params: [vrstaTecaja, valuta, datum, drzava, drzavaNaziv]
		});   
	}

	function getIznosDnevnice(drzava, kojaDnev, naDan) { 
		return $.dsDirectCall({ 
			method: "GetIznosDnevnice", 
			params: [drzava, kojaDnev, naDan]
		});   
	}	

	function getIznosDnevnicePutni(drzava, putni, putovanje, perDiem) { 
		return $.dsDirectCall({ 
			method: "GetIznosDnevnicePutni", 
			params: [drzava, putni, putovanje, perDiem]
		});   
	}	

	function getDnevnicaByDrzava(drzava, naDan) { 
		return $.dsDirectCall({ 
			method: "getDnevnicaByDrzava", 
			params: [drzava, naDan]
		});   
	}

	function opcinaById(opcina) { 
		return $.dsDirectCall({ 
			method: "sf/OpcinaById", 
			params: [opcina]
		});  
	}

	function knjigaSpById(knjigaSp) { 
		return $.dsDirectCall({ 
			method: "KnjigaSpById", 
			params: [knjigaSp]
		});  
	}

	function kontrolaKonta(vrKonta) { 
		return $.dsDirectCall({ 
			method: "KontrolaKonta", 
			params: [vrKonta]
		});  
	}
    
    function predloziIzVrKonta(vrKonta) {
    	return $.dsDirectCall({
    		method: "PredloziIzVrKonta",
    		params: [vrKonta]
    	});
    }

    function potpisnikPredlozi(putni, noviStatus) {
    	return $.dsDirectCall({
    		method: "potpisnikPredlozi",
    		params: [putni, noviStatus]
    	});
    }

    function tajnicaUpisala(putni, vrsta) {
    	return $.dsDirectCall({
    		method: "tajnicaUpisala",
    		params: [putni, vrsta]
    	});
    }

    function ponovnoSlanjeMaila(putni) {
    	return $.dsDirectCall({
    		method: "ponovnoSlanjeMaila",
    		params: [putni]
    	});
    }

    function rucnoSlanjeMaila(putni) {
    	return $.dsDirectCall({
    		method: "rucnoSlanjeMaila",
    		params: [putni]
    	});
    }

    function provjeriOvlastenjeOdobravanja(putni) {
    	return $.dsDirectCall({
    		method: "provjeriOvlastenjeOdobravanja",
    		params: [putni]
    	});
    }
    
	function getOpcijaIzStatusa(status) { 
		return $.dsDirectCall({ 
			method: "getOpcijaIzStatusa", 
			params: [status]
		});  
	}

	function getStatusSOpcijom(opcija, shema, bRaise) { 
		return $.dsDirectCall({ 
			method: "GetStatusSOpcijom",
			params: [opcija, shema, bRaise]
		});  
	}

	function getIznos1Km(vrVozila, vrKonta, vrstaPrijevoza, naDan) {
		return $.dsDirectCall({ 
			method: "GetIznos1Km",
			params: [vrVozila, vrKonta, vrstaPrijevoza, naDan]
		});  
	}

	function promjenaRedosljedaStavke(putni, putniRel, stavka, putovanje, tip) {
		return $.dsDirectCall({ 
			method: "PromjenaRedosljedaStavke",
			params: [putni, putniRel, stavka, putovanje, tip]
		});  
	}

	function getZOsobaByDjelatnik(djelatnik) {
		return $.dsDirectCall({ 
			method: "GetZOsobaByDjelatnik",
			params: [djelatnik]
		});  
	}

	function predloziNazivWebKorisnika(djelatnik) {
		return $.dsDirectCall({ 
			method: "PredloziNazivWebKorisnika",
			params: [djelatnik]
		});  
	}

	function webKorisnikJeKreiran(djelatnik) {
		return $.dsDirectCall({ 
			method: "WebKorisnikJeKreiran",
			params: [djelatnik]
		});  
	}

	function generirajWebKorisnikaNaMail(djelatnik, webKorisnik, email) {
		return $.dsDirectCall({ 
			method: "GenerirajWebKorisnikaNaMail",
			params: [djelatnik, webKorisnik, email]
		});  
	}

	function provjeriAkoJeNalogZakljucan(putni) {
		return $.dsDirectCall({ 
			method: "ProvjeriAkoJeNalogZakljucan",
			params: [putni]
		});  
	}

	function odobriAkontaciju(akontacija) {
		return $.dsDirectCall({ 
			method: "OdobriAkontaciju",
			params: [akontacija]
		});  
	}

	function odbijAkontaciju(akontacija) {
		return $.dsDirectCall({ 
			method: "OdbijAkontaciju",
			params: [akontacija]
		});  
	}

	function isplatiAkontaciju(akontacija) {
		return $.dsDirectCall({ 
			method: "IsplatiAkontaciju",
			params: [akontacija]
		});  
	}

	function ponistiIsplatuAkontacije(akontacija) {
		return $.dsDirectCall({ 
			method: "PonistiIsplatuAkontacije",
			params: [akontacija]
		});  
	}

	function odobriPutniOsoba(putniOsoba) {
		return $.dsDirectCall({ 
			method: "OdobriPutniOsoba",
			params: [putniOsoba]
		});  
	}

	function odobriPutniOsobaSve(putni) {
		return $.dsDirectCall({ 
			method: "OdobriPutniOsobaSve",
			params: [putni]
		});  
	}

	function odbijPutniOsoba(putniOsoba) {
		return $.dsDirectCall({ 
			method: "OdbijPutniOsoba",
			params: [putniOsoba]
		});  
	}

	function getVoziloById(vozilo) {
		return $.dsDirectCall({ 
			method: "VoziloById",
			params: [vozilo]
		});  
	}

	function getStatusi(nalog) {
		return $.dsDirectCall({ 
			method: "GetStatusi",
			params: [nalog]
		});  
	}
		
	function relacijaById(relacija) {
		return $.dsDirectCall({ 
			method: "RelacijaById",
			params: [relacija]
		});
	}		
	
	function postojeRelacije(putni) {
		return $.dsDirectCall({ 
			method: "PostojeRelacije",
			params: [putni]
		});
	}		

	function postojeDnevnice(putni, putovanje) {
		return $.dsDirectCall({ 
			method: "PostojeDnevnice",
			params: [putni, putovanje]
		});
	}		

	function getPutniById(putni) {
		return $.dsDirectCall({ 
			method: "PutniById",
			params: [putni]
		});
	}	
	
	function izracunajVrijemePrelaskaGranice(polazak, relacija) {
		return $.dsDirectCall({ 
			method: "izracunajVrijemePrelaskaGranice",
			params: [polazak, relacija]
		});
	}	
	 
	function izracunajTrajanjeIzDatuma(odlazak, povratak) {
		return $.dsDirectCall({ 
			method: "IzracunajTrajanjeIzDatuma",
			params: [odlazak, povratak]
		});
	}
	 
	function izracunajTrajanjeIzDecimalnog(sati) {
		return $.dsDirectCall({ 
			method: "izracunajTrajanjeIzDecimalnog",
			params: [sati]
		});
	}
	
	function izracunajTrajanjeIzSatiMinuta(sati, minute) {
		return $.dsDirectCall({ 
			method: "izracunajTrajanjeIzSatiMinuta",
			params: [sati, minute]
		});
	}	 

	function promjenaStatusaPoziv(putni, putniStatus, noviStatus, knjigaSp, zOsoba, obj) {
		return $.dsDirectCallPost({ 
			method: "PromjenaStatusaPoziv",
			controller: "putni",			
			params: [putni, putniStatus, noviStatus, knjigaSp, zOsoba],
			data: [ obj ]
		});
	}

	function promjenaStatusaPozivUPozadini(putni, putniStatus, noviStatus, knjigaSp, zOsoba, obj, errorOverride) {
		return $.dsDirectCallPost({ 
			method: "PromjenaStatusaPozivUPozadini",
			controller: "putni",			
			params: [putni, putniStatus, noviStatus, knjigaSp, zOsoba],
			data: [ obj ],
			fail: function (error, textStatus, jqXHR, logicalError){ 
				if (errorOverride){
					jqXHR.statusText = "errorOverride"; 
				}
				//ako nije uhvatit će ga $(document).ajaxError(KUtils.defaultAjaxErrorHandler); na main-template.tpl
			}
		});
	}
	 
	function promjenaStatusaPozivBezDizanjaErrora(putni, status, noviStatus, knjigaSp, zOsoba, obj, errorOverride) {
		return $.dsDirectCallPost({ 
			method: "PromjenaStatusaPozivBezDizanjaErrora",
			controller: "putni",			
			params: [putni, status, noviStatus, knjigaSp, zOsoba],
			data: [ obj ],
			fail: function (error, textStatus, jqXHR, logicalError){ 
				if (errorOverride){
					jqXHR.statusText = "errorOverride"; 
				}
				//ako nije uhvatit će ga $(document).ajaxError(KUtils.defaultAjaxErrorHandler); na main-template.tpl
			}
		});
	}	

	function getNalogeIstogZahtjeva(zahtjevPutni, status) {
		return $.dsDirectCall({ 
			method: "getNalogeIstogZahtjeva",
			params: [zahtjevPutni, status]	
		});
	}	
	
	function prenesiZahtjevUPn(putni) {
		return $.dsDirectCall({ 
			method: "PrenesiZahtjevUPn",
			params: [putni]
		}); 
	}
	
	function generirajRelacije(putni) {
		return $.dsDirectCall({ 
			method: "GenerirajRelacije",
			params: [putni]
		});
	}	
	
	function generirajDnevnice(putni, putovanje, direktanPoziv) {
		return $.dsDirectCall({ 
			method: "GenerirajDnevnice",
			params: [putni, putovanje, direktanPoziv]
		});
	}	

	function obracunDefault(putni) {
		return $.dsDirectCall({ 
			method: "ObracunDefault",
			params: [putni]
		});
	}			
	 	
	function getPocetnoStanjeKm(vozilo) {
		return $.dsDirectCall({ 
			method: "GetPocetnoStanjeKm",
			params: [vozilo]
		});
	}

	function getPocetnoStanjeKmIzRelacija(putni) {
		return $.dsDirectCall({ 
			method: "GetPocetnoStanjeKmIzRelacija",
			params: [putni]
		});
	}			 			 				 			 

	function getZavrsnoStanjeKmIzRelacija(putni, samoAkoNisuDodavaneRelacije) {
		return $.dsDirectCall({ 
			method: "GetZavrsnoStanjeKmIzRelacija",
			params: [putni, samoAkoNisuDodavaneRelacije]
		});
	}			 			 				 			 

	function getDatumIzRelacija(putni, pocetni) {
		return $.dsDirectCall({ 
			method: "GetDatumIzRelacija",
			params: [putni, pocetni]
		});
	}			 			 				 			 
	
	function getPutniAkFields() { 
		return $.dsDirectCall({ 
			method: "GetPutniAkFields"
		});  
	}

	function getPutniDnFields() { 
		return $.dsDirectCall({ 
			method: "GetPutniDnFields"
		});  
	}	

	function getPutniTrFields() { 
		return $.dsDirectCall({ 
			method: "GetPutniTrFields"
		});  
	}

	function getPutniRelFields(pregledZahtjeva) { 
		return $.dsDirectCall({ 
			method: "GetPutniRelFields",
			params: [pregledZahtjeva]
		});  
	}

	function getPutniOdFields() { 
		return $.dsDirectCall({ 
			method: "GetPutniOdFields"
		});  
	}

	function getPutniDetFields() { 
		return $.dsDirectCall({ 
			method: "GetPutniDetFields"			
		});  
	}

	function getPutniDetZahtjevFields() { 
		return $.dsDirectCall({ 
			method: "GetPutniDetZahtjevFields"			
		});  
	}

	function getPutniOsobaFields() { 
		return $.dsDirectCall({ 
			method: "GetPutniOsobaFields"
		});  
	}

	function renumerirajBrojeve(knjigaSp, datumOd, datumDo) {
		return $.dsDirectCall({ 
			method: "RenumerirajBrojeve",
			params: [knjigaSp, datumOd, datumDo]
		});
	}	

	function provjeriPotpisPoReduAsync(putni, status) {
		return $.dsDirectCall({ 
			method: "ProvjeriPotpisPoReduAsync",
			params: [putni, status]
		});  
	}

	function provjeriOdobravanjeNaRedu(putni) {
		return $.dsDirectCall({ 
			method: "ProvjeriOdobravanjeNaRedu",
			params: [putni]
		});  
	}

	function predloziAktivnostIIzvore(organ, mTroska, akt) {
		return $.dsDirectCall({ 
			method: "PredloziAktivnostIIzvore",
			params: [organ, mTroska, akt]
		});  
	}

	function getStatusiPromjena(trenutniPutni, vkShema, knjigaSPNalog, opcija, putni, uloga, rucnaPromjena) {
		return $.dsDirectCall({ 
			method: "GetStatusiPromjena",
			params: [trenutniPutni, vkShema, knjigaSPNalog, opcija, putni, uloga, rucnaPromjena]
		});  
	}

	function sljedeciOdobravatelj(putni) { 
		return $.dsDirectCall({ 
			method: "sljedeciOdobravatelj", 
			params: [putni]
		});  
	}

	function deaktivirajOvlastenje(ovlastenje) { 
		return $.dsDirectCall({ 
			method: "deaktivirajOvlastenje", 
			params: [ovlastenje]
		});  
	}

	function otvoriNovuGodinu(novaGodina) {
		return $.dsDirectCall({ 
			method: "OtvoriNovuGodinu",
			params: [novaGodina]
		});
	}	

    function vratiDatumZaRacunanjeDnevniceWEB(putni, putovanje) {
        return $.dsDirectCall({ 
            method: "vratiDatumZaRacunanjeDnevniceWEB",
            params: [putni, putovanje]
        });  
    }

	function vratiDatumPocetkaPutovanjaWEB(putni, putovanje) {
		return $.dsDirectCall({ 
			method: "vratiDatumPocetkaPutovanjaWEB",
			params: [putni, putovanje]
		});  
	}

    function vratiDatumKrajaPutovanjaWEB(putni, putovanje) {
        return $.dsDirectCall({ 
            method: "vratiDatumKrajaPutovanjaWEB",
            params: [putni, putovanje]
        });  
    }

    function vratiDatumZaTroskovePrijevozaWEB(putni, putovanje) {
        return $.dsDirectCall({ 
            method: "vratiDatumZaTroskovePrijevozaWEB",
            params: [putni, putovanje]
        });  
    }

	function dohvatiZadnjiVrijediDoDnevnice(drzava, valuta) {
		return $.dsDirectCall({ 
			method: "dohvatiZadnjiVrijediDoDnevnice",
			params: [drzava, valuta]
		});  
	}

	function vratiSveNeodobreneOsobe(putni) {
		return $.dsDirectCall({ 
			method: "VratiSveNeodobreneOsobe",
			params: [putni]
		});
	}	

	function kopirajObracun(izPutni, uPutni) {
		return $.dsDirectCall({ 
			method: "kopirajObracun",
			params: [izPutni, uPutni]
		});
	}	

	function azurirajStatusUPozadini(putni, postavi) {
		return $.dsDirectCall({ 
			method: "AzurirajStatusUPozadini",
			params: [putni, postavi]
		});
	}	

	function posloziOpisPrijevoza(tekst, vrKonta) {
		return $.dsDirectCall({ 
			method: "PosloziOpisPrijevoza",
			params: [tekst, vrKonta]
		});
	}	
	
	function GetPutniKalendarEvents(params, mjesec, godina){
		return $.dsDirectCall({
			method: "GetPutniKalendarEvents",
			params: [ params, mjesec, godina ]
		});
	} 
	
	function DjelatnikById(djelatnik) {
		return $.dsDirectCall({ 
			method: "DjelatnikById",
			params: [djelatnik]
		});
	}
	
	function ProvjeriAutomatskiUpisOdredista(putniRel){
		return $.dsDirectCall({ 
			method: "ProvjeriAutomatskiUpisOdredista",
			params: [putniRel]
		});
	} 

	function IstoVoziloPoRegOznaka(iVozilo, sRegOznaka) {
		return $.dsDirectCall({ 
			method: "IstoVoziloPoRegOznaka",
			params: [iVozilo, sRegOznaka]
		});
	}

	function GetDefVoziloZaVrstuPrijevoza(iVrstaPrijevoza) {
		return $.dsDirectCall({ 
			method: "GetDefVoziloZaVrstuPrijevoza",
			params: [iVrstaPrijevoza]
		});
	}

	function VratiSljedecuSifruDjelatnika() { 
		return $.dsDirectCall({ 
			method: "VratiSljedecuSifruDjelatnika"
		});   
	}

	function ProvjeriSifruDjelatnika(iDjelatnik) { 
		return $.dsDirectCall({ 
			method: "ProvjeriSifruDjelatnika",
			params: [iDjelatnik]			
		});   
	}

	function azurInoDnev2024(datumOd) {
		return $.dsDirectCall({ 
			method: "azurInoDnev2024",
			params: [datumOd]
		});
	}
	
	function ProvjeriZauzetostVozila(vozilo, polazak, povratak, putni) {
		return $.dsDirectCall({ 
			method: "ProvjeriZauzetostVozila",
			params: [vozilo, polazak, povratak, putni]
		});
	}	
	
	function dohvatiHrmSifarnike(hrmTablica) {
		return $.dsDirectCall({ 
			method: "dohvatiHrmSifarnike",
			params: [hrmTablica]
		});
	}		

	function posaljiNalogUHrmTravel(putni) {
		return $.dsDirectCall({ 
			method: "posaljiNalogUHrmTravel",
			params: [putni]
		});
	}			

} (konto.sp.api = {}));